import { createContext } from 'react';
import { DataRoomShareableLink } from 'models/ShareableLink';

type ShareableLinkDataContextProps = {
  shareableLink: DataRoomShareableLink;
};

export default createContext<Partial<ShareableLinkDataContextProps>>({
  shareableLink: null,
});
